import { useLayoutEffect, useRef, useState, type RefObject } from "react";

import type { SelectSize } from "./types";

/** Web: the trigger's touch area is a class (`minTouchTargetClassName`), so no props. */
export const selectTriggerTouchProps = (_size: SelectSize) => ({});

/** Web: the combobox's value is its text (the selected label), so no props. */
export const selectTriggerValueProps = (_selectedLabel: string | undefined) => ({});

/**
 * Web: the trigger's name. `accessibilityLabel` when it's given; otherwise a
 * `<label for>` linked to the trigger names it, so no `aria-label` overrides
 * it; otherwise the placeholder.
 */
export function useSelectTriggerName(
  triggerRef: RefObject<unknown>,
  accessibilityLabel: string | undefined,
  placeholder: string | undefined,
) {
  const [hasLinkedLabel, setHasLinkedLabel] = useState(false);
  const linkedRef = useRef(false);
  // No deps: a Label can render before or after the Select, or later, so this
  // checks again after each commit, and sets state only when the answer changes
  useLayoutEffect(() => {
    const linked = Boolean((triggerRef.current as HTMLButtonElement | null)?.labels?.length);
    if (linked !== linkedRef.current) {
      linkedRef.current = linked;
      setHasLinkedLabel(linked);
    }
  });
  return accessibilityLabel ?? (hasLinkedLabel ? undefined : placeholder);
}
